import React, { useEffect, useState, useContext, useRef } from "react";
import moment from "moment";
import {
  OK_INDEX,
  WARNING_INDEX,
  WIP_INDEX,
  CRITICAL_INDEX,
  IMPACT_INDEX,
  EXPIRED_INDEX,
} from "../../helpers/pinPostions";
import history from "../../helpers/history";
import getStatus from "../../helpers/statuses";
import MapContext from "../../contexts/Map";
import { toggleMap } from "../../actions/Map";
import { useWindowSize } from "../../hooks/window";
import { put, get } from "../../api";
import Button from "../Button";
import Loading from "../Loading";
import styles from "./Map.module.scss";
import NavContext from "../../contexts/Nav";
import { useMediaQuery } from "react-responsive";
import { useConfirm } from "material-ui-confirm";
import {
  SENTINEL_TMA,
  SENTINEL_MOBILE_TRACKER,
  SENTINEL_TRACKER,
} from "../../constants/sentinel_types.js";
import Modal from "../../components/Modal";
import TextInput from "../../components/TextInput";
import Label from "../../components/Label";
import InputRow from "../../components/InputRow";
import { SYS_ADMIN, TENANT_ADMIN } from "../../constants/roles";
import { isAuthorized } from "../../helpers/authorization";
import { AuthContext } from "../../contexts/Auth";
import "./Map.css";
import { DateTime } from "luxon";
import Calendar from "../../components/Calendar";
import {
  setDeploymentMarkers,
  removeDeploymentMarkers,
  toggleHistoryFullscreen,
} from "../../actions/Map";

const google = window.google;
const popoverTemplate = `

  <div class="map-popover">
    <label class="map-popover__label">Asset name</label>
    <div class="map-popover__name">{assetName}</div>
    <label class="map-popover__label">Type</label>
    <div class="map-popover__status">
      <span>Impact Tracker</span>
    </div>
    <label class="map-popover__label">Status</label>
    <div class="map-popover__status">
      <span class="map-popover__icon map-popover__icon--{status} material-icons">{icon}</span>
      <span>{statusName}</span>
    </div>

  </div>
`;

const popoverTemplateTracker = `

  <div class="map-popover">
    <label class="map-popover__label">Asset name</label>
    <div class="map-popover__name">{assetName}</div>
    <label class="map-popover__label">Type</label>
    <div class="map-popover__status">
      <span>Tracker</span>
    </div>
    <label class="map-popover__label">Last update:</label>
    <div class="map-popover__status">
      <span>{lastUpdatedTracker}</span>
    </div>

  </div>
`;

const popoverTemplateMobile = `

  <div class="map-popover">
    <label class="map-popover__label">Asset name</label>
    <div class="map-popover__name">{assetName}</div>
    <label class="map-popover__label">Type</label>
    <div class="map-popover__status">
      <span>TMA Mobile</span>
    </div>
    <label class="map-popover__label">Status</label>
    <div class="map-popover__status">
      <span class="map-popover__icon map-popover__icon--{status} material-icons">{icon}</span>
      <span>{statusName} - {deployment}</span>
    </div>

  </div>
`;
const popoverTemplateNoGroup = `
  <div class="map-popover">
    <label class="map-popover__label">Serial Number:</label>
    <div class="map-popover__name">{assetName}</div>
    <label class="map-popover__label">Status</label>
    <div class="map-popover__status">
      <span class="map-popover__icon map-popover__icon--{status} material-icons">{icon}</span>
      <span>{statusName}</span>
    </div>
    <div class="map-popover__firmware">
      <label class="map-popover__label">Firmware</label>
      <span>{firmware}</span>
  </div>
`;

function getPopoverTemplate(marker) {
  // Tracker-specific template
  if (marker.devicetype_id === SENTINEL_TRACKER) {
    return popoverTemplateTracker;
  }

  // Mobile-specific template
  if (
    marker.devicetype_id === SENTINEL_MOBILE_TRACKER ||
    marker.devicetype_id === SENTINEL_TMA ||
    marker.devicetype_id === SENTINEL_TMA
  ) {
    return popoverTemplateMobile;
  }

  // Existing behavior
  if (marker.assets) {
    return popoverTemplate;
  }

  return popoverTemplateNoGroup;
}
const defaultBonds = { lat: 10.7, lng: -10.8 };
const defaultBondsSmallMap = { lat: 0.0, lng: 10.2 };
let markers = [];

var desired_zoom_level = 17; //range 2-22

export default function Map({ customBackButton = false }) {
  const { height } = useWindowSize();
  const [showDebugTools, setShowDebugTools] = useState(false);
  const [state, dispatch] = useContext(MapContext);

  const { state: user } = useContext(AuthContext);
  const { isNavShowing, setIsNavShowing } = useContext(NavContext);
  const [loading, setLoading] = useState(true);
  const [enableTrafficLayer, setEnableTrafficLayer] = useState(false);
  const [map, setMap] = useState(null);
  const [controlsChanged, setControlsChanged] = useState(false);
  const [streetView, setStreetView] = useState(false);
  const [bounds, setBounds] = useState(new google.maps.LatLngBounds());
  const [boundsChanged, setBoundsChanged] = useState(false);
  const zoomMapQuery3 = useMediaQuery({
    query:
      "(min-width: 768px) and (max-width: 1024px) and (orientation : portrait), (min-width: 1024px) and (max-width: 1366px)",
  });
  const zoomMapQuery2 = useMediaQuery({ query: "(max-width: 600px)" });
  const confirm = useConfirm();
  const [gpsModal, openGpsModal] = useState(false);
  const [deviceHistoryDatesRaw, setDeviceHistoryDatesRaw] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(true);
  const [historyDayLoading, setHistoryDayLoading] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [historyDate, setHistoryDate] = useState("");
  const [staticImgUrl, setStaticImgUrl] = useState(null);
  const [showStaticImage, setShowStaticImage] = useState(false);
  const [availableDates, setAvailableDates] = useState([]);
  const [disabledDates, setDisabledDates] = useState([]);
  const [pickerState, setPickerState] = useState(new Date());
  const [bbModeModal, setbbModeModal] = useState(true);
  const [gpsUserPosition, setGpsUserPosition] = useState({});
  const [mapMovementDisabled, setMapMovementDisabled] = useState(false);
  const [roadPathData, setRoadPathData] = useState(null);
  const isAdmin = isAuthorized(user.user.roles, [SYS_ADMIN, TENANT_ADMIN]);
  // … your existing hooks …
  const [historyMarkersArray, setHistoryMarkersArray] = useState([]);
  const [historyDataArray, setHistoryDataArray] = useState([]);
  const [currentHistoryIndex, setCurrentHistoryIndex] = useState(0);
  const [activeInfoWindow, setActiveInfoWindow] = useState(null);
  const activeInfoWindowRef = useRef(null);
  const [isCalendarVisible, setIsCalendarVisible] = useState(true);

  // Returns the focused (isolated) device marker, or falls back to markers[0]
  function getIsolatedMarker() {
    if (state.isolatedMarker && state.markers && state.markers.length > 0) {
      const [lng, lat] = state.isolatedMarker;
      const match = state.markers.find(
        (m) => m.longitude === lng && m.latitude === lat
      );
      if (match) return match;
    }
    return state.markers && state.markers.length > 0 ? state.markers[0] : null;
  }

  // Toggle fullscreen when calendar is opened/closed
  const toggleCalendarAndFullscreen = () => {
    const newShowCalendar = !showCalendar;
    setShowCalendar(newShowCalendar);
    if (newShowCalendar) setIsCalendarVisible(true);
    dispatch(toggleHistoryFullscreen());

    // If closing, clear deployment markers and reset history state
    if (!newShowCalendar) {
      // First, set loading to true to trigger cleanup
      setHistoryDayLoading(true);

      // Clear all history markers and overlays from the map
      if (window.previousMarkers.length > 0) {
        window.previousMarkers.forEach((marker) => {
          if (marker) marker.setMap(null);
        });
        window.previousMarkers = [];
      }

      if (window.previousPolylines.length > 0) {
        window.previousPolylines.forEach((polyline) => {
          if (polyline) polyline.setMap(null);
        });
        window.previousPolylines = [];
      }

      if (window.previousCircles.length > 0) {
        window.previousCircles.forEach((circle) => {
          if (circle) circle.setMap(null);
        });
        window.previousCircles = [];
      }

      // Clear map overlays
      if (map) {
        map.clearOverlays();
        map.clearPolygons();
      }

      // Clear state and close info windows
      if (activeInfoWindowRef.current) {
        activeInfoWindowRef.current.close();
      }
      activeInfoWindowRef.current = null;
      setActiveInfoWindow(null);
      setHistoryMarkersArray([]);
      setHistoryDataArray([]);
      setCurrentHistoryIndex(0);
      setHistoryDate("");

      // Clear deployment markers from Redux and trigger re-render
      dispatch(removeDeploymentMarkers());

      // Set loading to false after a brief delay to ensure re-render
      setTimeout(() => {
        setHistoryDayLoading(false);
      }, 100);
    }
  };

  // helper to move to a given history step:
  // 2) Updated goHistoryStep — closes the old window, animates pan, then opens the new one:
  const goHistoryStep = (newIdx) => {
    if (!map || historyMarkersArray.length === 0) return;

    // Close previous info window
    if (activeInfoWindowRef.current) {
      activeInfoWindowRef.current.close();
    }

    const newMarker = historyMarkersArray[newIdx];
    const toPos = newMarker.getPosition();
    const toZoom = desired_zoom_level; // e.g. 17

    // smoothly pan + zoom, then open the new popup
    map.panTo(toPos);
    map.setZoom(toZoom);

    // Open new info window
    const historyData = historyDataArray[newIdx];
    const infoWindow = createHistoryInfoWindow(historyData, newMarker);
    infoWindow.open(map, newMarker);
    activeInfoWindowRef.current = infoWindow;
    setActiveInfoWindow(infoWindow);
    setCurrentHistoryIndex(newIdx);
  };

  // Create info window for history marker
  const createHistoryInfoWindow = (data, marker) => {
    const isDeployed =
      data.deployment_status === 0 || data.deployment_status === "deployed";
    const isHalfDeployed =
      data.deployment_status === 4 ||
      data.deployment_status === "4" ||
      data.deployment_status === "half_deployed";

    let badgeOrText = '<span style="background: rgba(169, 169, 169, 0.75); color: white; padding: 4px 12px; border-radius: 12px; font-size: 0.85em; font-weight: 600;">⏸️ Not Deployed</span>';

    if (isDeployed) {
      badgeOrText = '<span style="background: rgba(5, 176, 8, 0.85); color: white; padding: 4px 12px; border-radius: 12px; font-size: 0.85em; font-weight: 600;">Deployed</span>';
    } else if (isHalfDeployed) {
      badgeOrText = '<span style="background: #f59e0b; color: white; padding: 4px 12px; border-radius: 12px; font-size: 0.85em; font-weight: 600;">⚠️ Half Deployed</span>';
    }

    const content = `
      <div style="padding: 12px; font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif; min-width: 280px;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
          <div style="font-size: 1.1em; font-weight: 600; color: #242424;">Position Data</div>
          ${badgeOrText}
        </div>

        <div style="background: rgba(242, 105, 37, 0.75); border-radius: 12px; padding: 16px; margin-bottom: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
          <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px;">
            <div style="text-align: center;">
              <div style="color: rgba(255,255,255,0.95); font-size: 0.75em; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 4px;">Speed</div>
<div style="color: white; font-size: 1.5em; font-weight: 700;">${data.speed !== undefined && data.speed !== null
        ? data.speed.toFixed(0)
        : "—"
      }</div>
              <div style="color: rgba(255,255,255,0.85); font-size: 0.7em;">mph</div>               </div>
            <div style="text-align: center;">
              <div style="color: rgba(255,255,255,0.95); font-size: 0.75em; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 4px;">Heading</div>
              <div style="color: white; font-size: 1.5em; font-weight: 700;">${data.heading !== undefined && data.heading !== null
        ? data.heading.toFixed(0)
        : "—"
      }°</div>
              <div style="color: rgba(255,255,255,0.85); font-size: 0.7em;">${getHeadingDirection(
        data.heading,
      )}</div>
            </div>

          </div>
        </div>

        <div style="color: #777777; font-size: 0.85em; margin-top: 8px;">
          <div style="margin-bottom: 4px;">
            <span style="font-weight: 600;">Lat:</span> ${data.latitude.toFixed(
        6,
      )}
          </div>
          <div style="margin-bottom: 4px;">
            <span style="font-weight: 600;">Lng:</span> ${data.longitude.toFixed(
        6,
      )}
          </div>
          <div style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #e5e5e5;">
             ${moment(data.created_time).format("MMM D, YYYY h:mm:ss A")}
          </div>
        </div>
      </div>
    `;

    return new google.maps.InfoWindow({
      content: content,
      closeBoxURL: "",
    });
  };

  // Helper function to convert heading degrees to cardinal direction
  const getHeadingDirection = (heading) => {
    if (heading === undefined || heading === null) return "";
    const directions = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"];
    const index = Math.round((heading % 360) / 45) % 8;
    return directions[index];
  };

  useEffect(() => {
    if (historyLoading) return;

    const deviceHistoryData = deviceHistoryDatesRaw?.map((d) => {
      return DateTime.fromSeconds(parseInt(d?.slice(6, 16))).toJSDate();
    });

    deviceHistoryData && setAvailableDates(deviceHistoryData);
  }, [historyLoading]);

  useEffect(() => {
    var getDaysArray = function (start, end) {
      for (
        var arr = [], dt = new Date(start);
        dt <= new Date(end);
        dt.setDate(dt.getDate() + 1)
      ) {
        arr.push(new Date(dt));
      }
      return arr;
    };
    if (!availableDates || !availableDates?.length) {
      return;
    }

    if (availableDates?.length < 2) return;
    const datesInRange = getDaysArray(
      availableDates?.[0],
      availableDates[availableDates?.length - 1],
    );
    setDisabledDates(
      datesInRange
        .map((date) => {
          if (
            availableDates.some(
              (element) => element.getTime() === date.getTime(),
            )
          )
            return null;
          else return date;
        })
        .filter(Boolean),
    );
    setPickerState(availableDates[availableDates?.length - 1]);
  }, [availableDates]);
  const subtlePhotoStyles = [
    // Kill all POIs (parks, businesses, landmarks)
    { featureType: "poi", stylers: [{ visibility: "off" }] },
    { featureType: "poi.park", stylers: [{ visibility: "off" }] },
    { featureType: "poi.business", stylers: [{ visibility: "off" }] },
    { featureType: "poi.attraction", stylers: [{ visibility: "off" }] },

    // Remove transit layers/icons
    { featureType: "transit", stylers: [{ visibility: "off" }] },

    // Turn off natural terrain shading
    {
      featureType: "landscape.natural",
      stylers: [{ saturation: -70 }, { lightness: 20 }],
    },
    { featureType: "landscape.man_made", stylers: [{ visibility: "off" }] },

    // Ensure administrative labels are visible for satellite view clarity
    {
      featureType: "administrative.land_parcel",
      elementType: "labels",
      stylers: [{ visibility: "on" }],
    },
    {
      featureType: "administrative.neighborhood",
      elementType: "labels",
      stylers: [{ visibility: "on" }],
    },
    {
      featureType: "administrative.locality",
      elementType: "labels",
      stylers: [{ visibility: "on" }],
    },
    {
      featureType: "administrative.country",
      elementType: "labels",
      stylers: [{ visibility: "on" }],
    },
    {
      featureType: "administrative.province",
      elementType: "labels",
      stylers: [{ visibility: "on" }],
    },
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [{ visibility: "on" }],
    },
    {
      featureType: "administrative",
      elementType: "labels.text.stroke",
      stylers: [{ visibility: "on" }],
    },

    // Ensure road labels are visible
    {
      featureType: "road",
      elementType: "labels",
      stylers: [{ visibility: "on" }],
    },
    {
      featureType: "road",
      elementType: "labels.icon",
      stylers: [{ visibility: "on" }],
    },

    // Ensure water labels are visible
    {
      featureType: "water",
      elementType: "labels",
      stylers: [{ visibility: "on" }],
    },

    // Ensure all other labels are visible by default unless explicitly turned off
    { elementType: "labels.icon", stylers: [{ visibility: "on" }] }, // Re-enable icons
    {
      featureType: "poi",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    }, // Keep POI labels off as per original intent
    {
      featureType: "transit",
      elementType: "labels",
      stylers: [{ visibility: "on" }],
    }, // Re-enable transit labels
  ];

  useEffect(() => {
    zoomMapQuery2 &&
      window.sessionStorage.getItem("bbMode") === "true" &&
      window.sessionStorage.getItem("qrRedirect") != "true" &&
      history.push(`/assets`);
    const init = new google.maps.Map(document.getElementById("map"), {
      center:
        state.centerSmallMap === false
          ? new google.maps.LatLng(defaultBonds?.lat, defaultBonds?.lng)
          : new google.maps.LatLng(
            defaultBondsSmallMap?.lat,
            defaultBondsSmallMap?.lng,
          ),
      zoom: 3,
      //styles: subtlePhotoStyles,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      gestureHandling: "greedy",
      panControl: false,
      panControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },
      rotateControl: false,
      rotateControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM,
      },
      zoomControl: true,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
      },

      mapTypeControl: true,
      mapTypeControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP,
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        mapTypeIds: ["roadmap", "satellite"],
      },
      streetViewControl: true,
      streetViewControlOptions: {
        //  position: google.maps.ControlPosition.LEFT_TOP,
      },
    });

    const trafficLayer = new google.maps.TrafficLayer();
    //if single marker then enabled traffic layer
    enableTrafficLayer && trafficLayer.setMap(init);

    setMap(init);
    setLoading(false);

    setTimeout(function () {
      google.maps.event.addListener(init, "bounds_changed", function () {
        setBoundsChanged(true);
      });
      google.maps.event.addListener(init, "mouseover", () => {
        setControlsChanged(true);
      });
      google.maps.event.addListener(init, "mouseup", () => {
        setControlsChanged(true);
      });
    }, 1500);
  }, [enableTrafficLayer]);

  function getPinIcon(marker) {
    var status = getStatus(marker.status);
    if (
      marker.devicetypeid === SENTINEL_TMA ||
      marker.devicetypeid === SENTINEL_MOBILE_TRACKER
    ) {
      switch (status.pin) {
        case "ok":
          return "/pins/tma_ok.png";
        case "warning":
          return "/pins/tma_warning.png";
        case "critical":
          return "/pins/tma_critical.png";
        case "impact":
          return "/pins/tma_impact.png";
        case "in_progress":
          return "/pins/tma_in_progress_shadow.png";
        case "inactive":
          return "/pins/_inactive.png";
        default:
          break;
      }
      /* switch (status.pin) {
         case "ok":
           return "/pins/sentinel_tracker.png";
         case "impact":
           return "/pins/sentinel_tracker_impact.png";
         case "warning":
         case "critical":
           return "/pins/sentinel_tracker_warning.png";
         default:
           return "/pins/sentinel_tracker.png";
       }
      if (marker.deployment_status) {
        return "/pins/tma_deployed.png";
      } else {
        return "/pins/tma_not_deployed.png";
      }*/
    } else if (marker.devicetypeid === SENTINEL_TRACKER) {
      switch (status.pin) {
        case "ok":
          return "/pins/sentinel_tracker.png";
        case "warning":
        case "critical":
          return "/pins/sentinel_tracker_warning.png";
        default:
          return "/pins/sentinel_tracker.png";
      }
    } else {
      //return "/pins/impact_new.png";
      switch (status.pin) {
        case "ok":
          return "/pins/ok.png";
        case "warning":
          return "/pins/warning.png";
        case "critical":
          return "/pins/critical.png";
        case "impact":
          return "/pins/impact.png";
        case "in_progress":
          return "/pins/in_progress_shadow.png";
        case "expired":
          return "/pins/expired.png";
        case "no_group":
          return "/pins/no_group.png";
        case "schedule":
          return "/pins/no_group.png";
        case "inactive":
          return "/pins/inactive.png";
        default:
          break;
      }
    }
  }

  google.maps.Map.prototype.clearOverlays = function () {
    for (var i = 0; i < markers.length; i++) {
      markers[i].setMap(null);
    }
    markers.length = 0;
  };

  google.maps.Map.prototype.clearPolygons = function () {
    if (window.previousPolylines && Array.isArray(window.previousPolylines)) {
      window.previousPolylines.forEach((poly) => {
        if (poly && typeof poly.setMap === "function") {
          poly.setMap(null);
        }
      });
      window.previousPolylines.length = 0;
    }
    if (window.previousCircles && Array.isArray(window.previousCircles)) {
      window.previousCircles.forEach((circle) => {
        if (circle && typeof circle.setMap === "function") {
          circle.setMap(null);
        }
      });
      window.previousCircles.length = 0;
    }
  };
  function getZIndexValue(marker) {
    var status = getStatus(marker.status);
    switch (status.pin) {
      case "ok":
        return OK_INDEX;
      case "warning":
        return WARNING_INDEX;
      case "in_progress":
        return WIP_INDEX;
      case "impact":
        return IMPACT_INDEX;
      case "critical":
        return CRITICAL_INDEX;
      case "expired":
        return EXPIRED_INDEX;
      case "schedule":
        return OK_INDEX;
      default:
        break;
    }
  }

  // ==================== GLOBAL VARIABLES =========================
  window.previousMarkers = window.previousMarkers || [];
  window.previousPolylines = window.previousPolylines || [];
  window.previousCircles = window.previousCircles || [];
  let mainDirectionsRenderer = null; // 🆕 Only one DirectionsRenderer reused globally
  // =============================================================

  async function drawHistoryOnMap(res) {
    setHistoryDayLoading(true);
    setStaticImgUrl(null);
    setRoadPathData(null);
    setCurrentHistoryIndex(0);
    setEnableTrafficLayer(false);
    // Clear previous markers and overlays
    if (window.previousMarkers.length > 0) {
      window.previousMarkers.forEach((marker) => {
        if (marker) marker.setMap(null);
      });
      window.previousMarkers = [];
    }

    if (window.previousPolylines.length > 0) {
      window.previousPolylines.forEach((polyline) => {
        if (polyline) polyline.setMap(null);
      });
      window.previousPolylines = [];
    }

    if (window.previousCircles.length > 0) {
      window.previousCircles.forEach((circle) => {
        if (circle) circle.setMap(null);
      });
      window.previousCircles = [];
    }

    if (map) {
      map.clearOverlays();
      map.clearPolygons();
    }

    // Clear directions renderer
    if (mainDirectionsRenderer) {
      mainDirectionsRenderer.setMap(null);
      mainDirectionsRenderer.setDirections({ routes: [] });
    }

    // Ensure no lingering markers in the global `markers` array
    if (markers.length > 0) {
      markers.forEach((marker) => {
        if (marker) marker.setMap(null);
      });
      markers = [];
    }

    // ====== CLEANUP PREVIOUS ELEMENTS ======
    // (already handled above)

    // ====== CLEAR previous route ======
    if (!mainDirectionsRenderer) {
      mainDirectionsRenderer = new google.maps.DirectionsRenderer();
    }
    mainDirectionsRenderer.setMap(null);
    mainDirectionsRenderer.setDirections({ routes: [] });
    mainDirectionsRenderer.setMap(map);
    mainDirectionsRenderer.setOptions({
      suppressMarkers: true,
      preserveViewport: true,
    });

    const legs = [];
    const init_bounds = new google.maps.LatLngBounds();
    const directions = new google.maps.DirectionsService();
    const routesEnabled = false;

    if (routesEnabled) {
      if (res && res.length > 0) {
        // — Build the driving route in chunks (max 25 points) —
        const allMarkers = res
          .filter((m) => m.latitude !== 0 && m.longitude !== 0)
          .map((m) => ({ lat: m.latitude, lng: m.longitude }));
        const parts = [];
        const max = 24; // 23 waypoints + origin + dest = 25
        for (let i = 0; i < allMarkers.length; i += max) {
          parts.push(allMarkers.slice(i, i + max + 1));
        }
        parts.forEach((segment) => {
          const waypoints = segment.slice(1, -1).map((pt) => ({
            location: pt,
            stopover: false,
          }));
          directions.route(
            {
              origin: segment[0],
              destination: segment[segment.length - 1],
              waypoints,
              travelMode: google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
              if (status === google.maps.DirectionsStatus.OK) {
                mainDirectionsRenderer.setDirections(result);
                legs.push(result.routes[0].legs[0]);
                setRoadPathData(legs);
              } else {
                alert(`error fetching directions ${status}`);
              }
            },
          );
        });
      }
    }

    // — Build history markers & circles —
    const newHistoryMarkers = [];
    const newHistoryData = [];
    let counter = 0;
    const cellhistory = [];
    let previousPosition = { lat: 0, lng: 0 };

    // Create a mutable copy of the data to safely normalize status
    const mutableRes = res.map(item => ({ ...item }));
    console.log("History data sample (cloned):", mutableRes.slice(0, 3));

    mutableRes.forEach((history, index) => {
      if (history.latitude === 0 || history.longitude === 0) return;

      // Determine deployment status and color

      let color = "#6b7280"; // Green for deployed, gray for not deployed
      switch (history.deployment_status) {
        case "deployed":
        case 0:
        case "0":
          history.deployment_status = "deployed";
          color = "#10b981";
          break;
        case "not_deployed":
        case 1:
        case "1":
          history.deployment_status = "not_deployed";
          color = "#6b7280";
          break;
        case 4:
        case "4":
          history.deployment_status = "half_deployed";
          color = "#f59e0b";
          break;
        default:
          console.warn("Unknown status fell through:", history.deployment_status);
          history.deployment_status = "not_deployed";
      }

      // Create heading arrow icon with rotation
      let markerIcon;
      if (history.heading !== undefined && history.heading !== null) {
        // Arrow icon that rotates based on heading
        markerIcon = {
          path: "M 0,-2 L 1.5,2 L 0,1 L -1.5,2 Z",
          fillColor: color,
          fillOpacity: 0.9,
          strokeColor: "#ffffff",
          strokeWeight: 1,
          scale: 4,
          rotation: history.heading,
          anchor: new google.maps.Point(0, 0),
        };
      } else {
        // Circle icon for markers without heading
        markerIcon = {
          path: google.maps.SymbolPath.CIRCLE,
          fillOpacity: 0.7,
          fillColor: color,
          strokeOpacity: 0.9,
          strokeWeight: 2,
          strokeColor: "#ffffff",
          scale: 6,
        };
      }

      // marker
      const marker = new google.maps.Marker({
        position: { lat: history.latitude, lng: history.longitude },
        map: map,
        icon: markerIcon,
        zIndex: index,
      });

      // Add click listener to show info window
      marker.addListener("click", () => {
        if (activeInfoWindowRef.current) {
          activeInfoWindowRef.current.close();
        }
        const infoWindow = createHistoryInfoWindow(history, marker);
        infoWindow.open(map, marker);
        activeInfoWindowRef.current = infoWindow;
        setActiveInfoWindow(infoWindow);
        setCurrentHistoryIndex(index);
      });

      window.previousMarkers.push(marker);
      newHistoryMarkers.push(marker);
      newHistoryData.push(history);

      previousPosition = {
        lat: history.latitude,
        lng: history.longitude,
      };
      init_bounds.extend({
        lat: history.latitude,
        lng: history.longitude,
      });
      counter++;
    });

    // ====== DRAW LINES BETWEEN ALL MARKERS ======
    for (let i = 1; i < mutableRes.length; i++) {
      const prev = mutableRes[i - 1];
      const curr = mutableRes[i];
      if (
        prev.latitude === 0 ||
        prev.longitude === 0 ||
        curr.latitude === 0 ||
        curr.longitude === 0
      )
        continue;
      // Green if both are deployment, gray otherwise
      const isPrevDeployed =
        prev.deployment_status === 0 || prev.deployment_status === "deployed";
      const isCurrDeployed =
        curr.deployment_status === 0 || curr.deployment_status === "deployed";
      const isPrevHalfDeployed =
        prev.deployment_status === 4 ||
        prev.deployment_status === "half_deployed";
      const isCurrHalfDeployed =
        curr.deployment_status === 4 ||
        curr.deployment_status === "half_deployed";

      let color = "#6b7280"; // default gray
      if (isPrevDeployed && isCurrDeployed) {
        color = "#10b981"; // green
      } else if (isPrevHalfDeployed || isCurrHalfDeployed) {
        color = "#f59e0b"; // orange
      }

      const polyline = new google.maps.Polyline({
        path: [
          { lat: prev.latitude, lng: prev.longitude },
          { lat: curr.latitude, lng: curr.longitude },
        ],
        geodesic: true,
        strokeColor: color,
        strokeOpacity: 0.8,
        strokeWeight: 3,
        zIndex: 1,
      });
      polyline.setMap(map);
      window.previousPolylines.push(polyline);
    }

    // save for stepper & open first
    setHistoryMarkersArray(newHistoryMarkers);
    setHistoryDataArray(newHistoryData);
    setCurrentHistoryIndex(0);

    // fit to all markers
    if (mutableRes.length > 0) {
      map.fitBounds(init_bounds);
      // Prevent zooming in too far when markers are spread out
      const listener = google.maps.event.addListenerOnce(
        map,
        "bounds_changed",
        function () {
          const maxZoom = 17; // adjust as needed
          if (map.getZoom() > maxZoom) map.setZoom(maxZoom);
        },
      );
    }

    if (newHistoryMarkers.length) {
      const first = newHistoryMarkers[0];
      const firstData = newHistoryData[0];

      // Open first marker info window after a short delay to ensure map is ready
      setTimeout(() => {
        const infoWindow = createHistoryInfoWindow(firstData, first);
        infoWindow.open(map, first);
        activeInfoWindowRef.current = infoWindow;
        setActiveInfoWindow(infoWindow);
      }, 500);
    }

    setHistoryDayLoading(false);
  }

  async function getDeviceHistoryForDate(date) {
    setHistoryDate(date);
    setHistoryDayLoading(true); // Show loading state
    showDeviceHistoryForDate(date);
  }
  async function showDeviceHistoryForDate(date) {
    const focusedMarker = getIsolatedMarker();
    if (!focusedMarker) return;
    var res = await get(
      `/devices/${focusedMarker.id}/history_date?&date=${date ? date : historyDate
      }&timezoneOffset=${new Date().getTimezoneOffset()}`,
    );
    dispatch(removeDeploymentMarkers());

    res && dispatch(setDeploymentMarkers(res));
    //drawHistoryOnMap(res);
  }
  async function getDeviceSummary() {
    const focusedMarker = getIsolatedMarker();
    if (!focusedMarker) return;
    var res = await get(
      `/devices/${focusedMarker.id
      }/history_summary?timezoneOffset=${new Date().getTimezoneOffset()}`,
    );
    if (res) {
      var string = "";
      var formatDateArray = [];
      res.dates &&
        res.dates.forEach((date) => {
          formatDateArray.push(moment(date).format("YYYY/M/DD"));
          string += moment(date).format("YYYY/M/DD") + "              ";
        });
      if (res?.dates) {
        setDeviceHistoryDatesRaw(res.dates?.reverse());
      }

      setHistoryLoading(false);
    }
  }

  useEffect(() => {
    if (
      map &&
      state.deployment_markers &&
      state.deployment_markers.length > 0
    ) {
      drawHistoryOnMap(state.deployment_markers);
    }
  }, [map, state.deployment_markers]);

  const DEVICE_ICON_CONFIG = {
    [SENTINEL_TMA]: {
      // show the icon at 96x96 px, anchored bottom-center
      size: new google.maps.Size(40, 42),
      anchor: new google.maps.Point(0, 0),
    },
    [SENTINEL_MOBILE_TRACKER]: {
      size: new google.maps.Size(30, 30),
      anchor: new google.maps.Point(15, 15),
    },
    [SENTINEL_TRACKER]: {
      size: new google.maps.Size(25, 42),
      anchor: new google.maps.Point(0, 0),
    },
  };

  // Default fallback for unknown types
  const DEFAULT_ICON_CONFIG = {
    size: new google.maps.Size(25, 34),
    anchor: new google.maps.Point(12, 34),
  };

  useEffect(() => {
    if (map && !historyDayLoading && state.deployment_markers?.length === 0) {
      let points = [];
      var init_bounds = new google.maps.LatLngBounds();

      state.markers && state.markers?.length > 0 && getDeviceSummary();
      if (state.markers?.length) {
        map.clearOverlays();
        state?.markers
          .filter((x) => x.longitude !== 0)
          .map((marker) => {
            if (marker?.longitude && marker?.latitude) {
              if (marker.longitude !== 0 || marker.latitude !== 0) {
                const data = {
                  assetId: marker.assets && marker?.assets?.[0]?.id,
                  assetName: marker.assets
                    ? marker?.assets[0]?.name
                    : marker.serial_number,
                  longitude: marker.longitude,
                  latitude: marker.latitude,
                  lastUpdated: marker.status_updated_time,
                  status: marker.status,
                  firmware: marker.firmware,
                  devicetypeid: marker.devicetype_id,
                  deployment_status:
                    marker.deployment_status ?? marker?.assets?.[0]?.deployed,
                  groupName:
                    marker.assets &&
                    marker?.assets[0]?.groups &&
                    marker?.assets[0]?.groups.map((obj) => obj.name).join(", "),
                  primaryContact:
                    marker.assets &&
                    marker?.assets[0]?.groups &&
                    marker?.assets[0]?.groups
                      .map(
                        (obj) =>
                          obj.primary_contact &&
                          obj.primary_contact.first_name +
                          " " +
                          obj.primary_contact.last_name +
                          " " +
                          obj.primary_contact.phone,
                      )
                      .join(", "),
                };

                const isOlderThanXDays =
                  moment().diff(moment(data.lastUpdated), "days") > 2;

                let iconPin = getPinIcon(data);

                if (isAdmin && isOlderThanXDays) {
                  iconPin = "/pins/inactive.png";
                }
                const config =
                  DEVICE_ICON_CONFIG[marker.devicetype_id] ||
                  DEFAULT_ICON_CONFIG;

                if (
                  marker.deployment_status !== undefined &&
                  marker.deployment_status !== null
                ) {
                  config.size = new google.maps.Size(100, 40);
                }
                var image = {
                  url: iconPin,
                  size: config.size,
                  origin: new google.maps.Point(0, 0),
                  anchor: config.anchor,
                };

                const template = getPopoverTemplate(marker);
                const infowindow = new google.maps.InfoWindow({
                  content: template
                    .replace(/{assetName}/g, data.assetName)
                    .replace(
                      /{lastUpdated}/g,
                      moment(data.lastUpdated).fromNow(),
                    )
                    .replace(/{status}/g, data.status)
                    .replace(/{statusName}/g, getStatus(data.status).name)
                    .replace(/{icon}/g, getStatus(data.status).icon)
                    .replace(/{assetId}/g, data.assetId)
                    .replace(/{notificationGroup}/g, data.groupName)
                    .replace(/{primaryContact}/g, data.primaryContact)
                    .replace(/{firmware}/g, data.firmware)
                    .replace(
                      /{lastUpdatedTracker}/g,
                      moment(data.lastUpdated).local().format("LLL"),
                    )
                    .replace(
                      /{deployment}/g,
                      data.deployment_status === 0
                        ? "Deployed"
                        : data.deployment_status === 4
                          ? "Half Deployed"
                          : "Not Deployed",
                    ),
                  //.replace(/{siteName}/g,data.siteName)
                  // .replace(/{phoneNumber}/g, '<div class="map-popover__name">' + data.primaryContactNumber + '</div>'),
                  closeBoxURL: "",
                });

                var marker = new google.maps.Marker({
                  position: { lat: data.latitude, lng: data.longitude },
                  map: map,
                  icon: image,
                  assetId: data?.assetId,
                  zIndex: parseInt(getZIndexValue(data)),
                });

                marker.addListener("click", () => {
                  if (!state.isolatedMarker && marker.assetId !== undefined) {
                    history.push(`/assets/${marker.assetId}`);
                  }
                });

                /*marker.addListener('rightclick', () => {
                openInNewTab(`/assets/${marker.assetId}`);
              });*/

                marker.addListener("mouseover", () => {
                  infowindow.open(map, marker);
                  //var x = document.getElementsByClassName('gm-ui-hover-effect')[0].remove();
                });
                marker.addListener("mouseout", () => {
                  infowindow.close(map, marker);
                });
                data?.latitude &&
                  init_bounds.extend({
                    lat: data.latitude,
                    lng: data.longitude,
                  });

                markers.push(marker);

                if (data.longitude && data.latitude) {
                  return points.push(marker);
                }
              }
            }
            return false;
          });

        if (points.length !== 0) {
          setBounds(init_bounds);
          setBoundsChanged(false);

          if (state.isolatedMarker) {
            setEnableTrafficLayer(true);
            var point = {
              lat: state.isolatedMarker[1],
              lng: state.isolatedMarker[0],
            };
            //map.setTilt(45);
            map.setCenter(point);
            map.setZoom(desired_zoom_level);
          } else if (state.markers.length) {
            //map.setTilt(45);
            map.fitBounds(init_bounds);
            map.setCenter(init_bounds.getCenter());
            var swLat = init_bounds?.getSouthWest()?.lat();
            var swLng = init_bounds?.getSouthWest()?.lng();
            var neLat = init_bounds?.getNorthEast()?.lat();
            var neLng = init_bounds?.getNorthEast()?.lng();
            var latDiff = Math.abs(swLat - neLat);
            var swDiff = Math.abs(swLng - neLng);
            var boundsThreshold = 75;

            if (latDiff > boundsThreshold || swDiff > boundsThreshold) {
              if (zoomMapQuery3) {
                map.setZoom(3);
              }
              if (zoomMapQuery2) {
                map.setZoom(2);
              }
            }
          }
        }
      }
    }
  }, [
    map,
    state.markers,
    state.isolatedMarker,
    state.displayGPSbutton,
    state.centerSmallMap,
    state.isMapShowing,
    historyDayLoading,
  ]);

  useEffect(() => {
    if ((!state.markers || !state.markers.length) && state.centerSmallMap) {
      map.center = new google.maps.LatLng(
        defaultBondsSmallMap?.lat,
        defaultBondsSmallMap?.lng,
      );
      map.zoom = 2;
    }
  }, [state.centerSmallMap]);

  const showAllMarkers = () => {
    map.fitBounds(bounds);
    map.setCenter(bounds.getCenter());
  };

  const centerOnIsolatedMarker = () => {
    var point = {
      lat: state.isolatedMarker?.[1],
      lng: state.isolatedMarker?.[0],
    };
    map.setCenter(point);
    map.setZoom(desired_zoom_level);
    setBoundsChanged(false);
  };

  function _sendGpsRecalibrationRequest(id) {
    var res = put(`/devices/${id}/gps/1`);
    if (res) {
      confirm({
        description: "GPS will be recalibrated within 24 hours",
        title: null,
        dialogProps: { fullScreen: false },
        cancellationButtonProps: { color: "error", disabled: true },
        confirmationButtonProps: { color: "primary", disableRipple: true },
      })
        .then(() => { })
        .catch(() => {
          /* ... */
        });
    }
  }

  async function openStreetView() {
    if (streetView === false) {
      var point = {
        lat: state.isolatedMarker?.[1],
        lng: state.isolatedMarker?.[0],
      };
      const streetviewService = new google.maps.StreetViewService();
      await streetviewService.getPanorama(
        { location: point },
        (result, status) => {
          if (status === google.maps.StreetViewStatus.OK && result) {
            const panorama = new google.maps.StreetViewPanorama(
              document.getElementById("pano"),
              {
                position: point,
                panControl: false,
                linksControl: false,
              },
            );
            setStreetView(!streetView);
            map.setStreetView(panorama);
          } else {
            alert("Unable to load Street View. Select the location manually.");
            setStreetView(false);
            map.setStreetView(null);
          }
        },
      );
    } else {
      setStreetView(!streetView);
      map.setStreetView(null);
    }
  }

  function _renderFooter(gpsUserPosition) {
    return (
      <>
        <Button onClick={() => openGpsModal(false)}>Cancel</Button>
        <Button
          onClick={() => putGpsPosition()}
          theme="primary"
          disabled={
            !gpsUserPosition?.latitude ||
            !gpsUserPosition?.longitude ||
            longlatValidate(gpsUserPosition?.latitude, "lat") ||
            longlatValidate(gpsUserPosition?.longitude, "lon")
          }
        >
          Save
        </Button>
      </>
    );
  }

  async function putGpsPosition() {
    var res = await put(`/devices/${state.markers[0].id}/gpsposition`, {
      latitude: gpsUserPosition.latitude,
      longitude: gpsUserPosition.longitude,
    });

    if (res.ok) {
      window.location.reload();
    } else {
      confirm({
        description: "Something went wrong, Try again.",
        title: null,
        dialogProps: { fullScreen: false },
        cancellationButtonProps: { color: "error", disabled: true },
        confirmationButtonProps: { color: "primary", disableRipple: true },
      })
        .then(() => { })
        .catch(() => {
          /* ... */
        });
    }
  }

  function bbMode() {
    window.sessionStorage.setItem("bbMode", "true");
    setbbModeModal(false);
    history.push(`/assets`);
  }

  function desktopMode() {
    window.sessionStorage.setItem("bbMode", "false");
    setbbModeModal(false);
    history.push(`/assets`);
  }

  /**
   * Smoothly pan and zoom the map.
   *
   * @param {google.maps.Map} map
   * @param {google.maps.LatLng} fromLatLng
   * @param {google.maps.LatLng} toLatLng
   * @param {number} fromZoom
   * @param {number} toZoom
   * @param {number} duration  in ms
   * @param {Function} onComplete
   */
  function animatePanZoom(
    map,
    fromLatLng,
    toLatLng,
    fromZoom,
    toZoom,
    duration = 200,
    onComplete,
  ) {
    const frameRate = 60;
    const totalFrames = Math.round((duration / 1000) * frameRate);
    let frame = 0;

    const deltaLat = (toLatLng.lat() - fromLatLng.lat()) / totalFrames;
    const deltaLng = (toLatLng.lng() - fromLatLng.lng()) / totalFrames;
    const deltaZoom = (toZoom - fromZoom) / totalFrames;

    function step() {
      frame++;

      // compute intermediate position & zoom
      const curLat = fromLatLng.lat() + deltaLat * frame;
      const curLng = fromLatLng.lng() + deltaLng * frame;
      const curZoom = fromZoom + deltaZoom * frame;

      map.setCenter({ lat: curLat, lng: curLng });
      map.setZoom(curZoom);

      if (frame < totalFrames) {
        requestAnimationFrame(step);
      } else {
        // ensure final state snapped exactly
        map.setCenter(toLatLng);
        map.setZoom(toZoom);
        onComplete && onComplete();
      }
    }

    step();
  }

  function longlatValidate(val, pos) {
    if (val) {
      if (pos === "lat") {
        return !val.match(
          /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$/,
        );
      }
      if (pos === "lon") {
        return !val.match(
          /^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$/,
        );
      }
    } else {
      return null;
    }
  }

  return (
    <>
      <div id="pano" className={streetView === true ? styles.pano : ""}></div>

      {!loading &&
        state.markers.length == 1 &&
        state.markers?.[0] &&
        !(state.markers?.[0]?.longitude || state.markers?.[0]?.latitude) &&
        (state.markers?.[0].status === "OK" ||
          state.markers?.[0].status === "WORK_IN_PROGRESS" ||
          state.markers?.[0].status === "IMPACT") && (
          <>
            {gpsModal && (
              <Modal small footer={_renderFooter(gpsUserPosition)}>
                <InputRow>
                  <Label text="Latitude">
                    <TextInput
                      placeholder="eg. 38.907192"
                      error={
                        longlatValidate(gpsUserPosition.latitude, "lat") &&
                        "Enter a valid latitude."
                      }
                      value={gpsUserPosition.latitude}
                      onChange={(e) => {
                        setGpsUserPosition({
                          ...gpsUserPosition,
                          latitude: e.target.value,
                        });
                      }}
                    />
                  </Label>
                  <Label text="Longitude">
                    <TextInput
                      error={
                        longlatValidate(gpsUserPosition.longitude, "lon") &&
                        "Enter a valid longitude."
                      }
                      value={gpsUserPosition.longitude}
                      placeholder="eg. -77.036873"
                      onChange={(e) => {
                        setGpsUserPosition({
                          ...gpsUserPosition,
                          longitude: e.target.value,
                        });
                      }}
                    />
                  </Label>
                </InputRow>
              </Modal>
            )}

            <div className={styles.mapNoGpsOverlay}>
              <div className={styles.mapNoGpsOverlayBanner}>
                <div className={styles.mapNoGpsOverlayText}>
                  GPS is being recalibrated
                  <div className={styles.coordinatesButtonContainer}>
                    <Button
                      onClick={() => openGpsModal(true)}
                      theme="primary"
                      icon="add"
                    >
                      Add coordinates
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

      <div
        id="map"
        className={streetView === true ? styles.map : styles.mapFull}
      ></div>

      {/* Modern 2026 Timeline Slider */}
      {historyMarkersArray.length > 0 && historyDataArray.length > 0 && (
        <div className={styles.timelineContainer}>
          <div className={styles.timelineHeader}>
            <div className={styles.timelineTitle}>Route Timeline</div>
            <div className={styles.timelineStats}>
              <span className={styles.statItem}>
                {currentHistoryIndex + 1} / {historyMarkersArray.length}
              </span>
            </div>
          </div>

          <div className={styles.timelineControls}>
            <button
              className={styles.timelineButton}
              disabled={currentHistoryIndex === 0}
              onClick={() => goHistoryStep(currentHistoryIndex - 1)}
              title="Previous point"
            >
              <span className="material-icons">navigate_before</span>
            </button>

            <div className={styles.sliderContainer}>
              <input
                type="range"
                min="0"
                max={historyMarkersArray.length - 1}
                value={currentHistoryIndex}
                onChange={(e) => goHistoryStep(parseInt(e.target.value))}
                className={styles.timelineSlider}
              />
              <div className={styles.sliderTrack}>
                {historyDataArray.map((data, index) => {
                  const isDeployed =
                    data.deployment_status === 0 ||
                    data.deployment_status === "deployed";
                  const isHalfDeployed =
                    data.deployment_status === 4 ||
                    data.deployment_status === "4" ||
                    data.deployment_status === "half_deployed";
                  return (
                    <div
                      key={index}
                      className={`${styles.sliderDot} ${index === currentHistoryIndex
                        ? styles.sliderDotActive
                        : ""
                        } ${isDeployed
                          ? styles.sliderDotDeployed
                          : isHalfDeployed
                            ? styles.sliderDotHalfDeployed
                            : styles.sliderDotNotDeployed
                        }`}
                      style={{
                        left: `${(index / (historyMarkersArray.length - 1)) * 100
                          }%`,
                      }}
                      onClick={() => goHistoryStep(index)}
                      title={`${moment(data.created_time).format("h:mm A")} - ${isDeployed
                        ? "Deployed"
                        : isHalfDeployed
                          ? "Half Deployed"
                          : "Not Deployed"
                        }`}
                    />
                  );
                })}
              </div>
            </div>

            <button
              className={styles.timelineButton}
              disabled={currentHistoryIndex === historyMarkersArray.length - 1}
              onClick={() => goHistoryStep(currentHistoryIndex + 1)}
              title="Next point"
            >
              <span className="material-icons">navigate_next</span>
            </button>
          </div>


        </div>
      )}

      {showDebugTools && historyMarkersArray.length > 0 && (
        <>
          <div className={styles.historyStepper}>
            <button
              disabled={currentHistoryIndex === 0}
              onClick={() => goHistoryStep(currentHistoryIndex - 1)}
            >
              Prev
            </button>

            <span>
              {currentHistoryIndex + 1} / {historyMarkersArray.length}
            </span>

            <button
              disabled={currentHistoryIndex === historyMarkersArray.length - 1}
              onClick={() => goHistoryStep(currentHistoryIndex + 1)}
            >
              Next
            </button>
          </div>

          <div className={styles.historySlider}>
            {historyMarkersArray.map((_, index) => (
              <button
                key={index}
                className={
                  index === currentHistoryIndex
                    ? styles.activeSliderButton
                    : styles.sliderButton
                }
                onClick={() => goHistoryStep(index)}
              >
                {index + 1}
              </button>
            ))}
          </div>
        </>
      )}
      {bbModeModal &&
        zoomMapQuery2 &&
        !window.sessionStorage.getItem("bbMode") && (
          <Modal simpleMode>
            <span className={styles.simpleModeContainer}>
              <Button
                icon="directions_car"
                onClick={() => {
                  bbMode();
                }}
              >
                Driving mode
              </Button>
              <Button icon={"space_dashboard"} onClick={() => desktopMode()}>
                Dashboard mode
              </Button>
            </span>
          </Modal>
        )}

      {!loading && state.markers?.[0] && !state.isHistoryFullscreen && (
        <div className={styles.bottom}>
          {state.isolatedMarker ? (
            <>
              {(state.markers?.[0]?.devicetype_id == SENTINEL_TMA ||
                state.markers?.[0]?.devicetype_id == SENTINEL_TRACKER) && (
                  <Button
                    isLoading={historyLoading || historyDayLoading}
                    disabled={historyLoading || historyDayLoading}
                    margin={8}
                    icon="route"
                    onClick={toggleCalendarAndFullscreen}
                  >
                    Route history
                  </Button>
                )}
              <Button
                margin={8}
                icon="room"
                width="100"
                onClick={() =>
                  _sendGpsRecalibrationRequest(state.markers[0].id)
                }
              >
                Recalibrate GPS
              </Button>
              {state.markers?.[0]?.longitude &&
                state.markers?.[0]?.latitude && (
                  <Button
                    margin={8}
                    icon="streetview"
                    onClick={() => openStreetView()}
                  >
                    Street view
                  </Button>
                )}
              {boundsChanged === true && (
                <Button
                  icon="pin_drop"
                  onClick={() => centerOnIsolatedMarker()}
                >
                  Center on asset
                </Button>
              )}
              :
            </>
          ) : (
            <Button icon="zoom_out_map" onClick={() => showAllMarkers()}>
              View all
            </Button>
          )}
        </div>
      )}

      {/* Calendar Panel in Fullscreen Mode */}
      {state.isHistoryFullscreen && showCalendar && isCalendarVisible && (
        <div className={styles.calendarPanel}>
          <div className={styles.calendarPanelHeader}>
            <h3>Select Date</h3>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <button
                className={styles.closeCalendarButton}
                onClick={() => setIsCalendarVisible(false)}
                title="Hide Calendar"
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  color: "#6b7280",
                }}
              >
                <span className="material-icons">visibility_off</span>
              </button>
              <button
                className={styles.closeCalendarButton}
                onClick={toggleCalendarAndFullscreen}
                title="Close Route History"
              >
                <span className="material-icons">close</span>
              </button>
            </div>
          </div>
          <div className={styles.calendarPanelContent}>
            {historyDayLoading && (
              <div className={styles.calendarLoadingOverlay}>
                <Loading color="gray" size={48} />
                <p>Loading route history...</p>
              </div>
            )}
            <Calendar
              availableDates={availableDates}
              onChange={(date) => getDeviceHistoryForDate(date)}
            />
          </div>
        </div>
      )}
      {state.isHistoryFullscreen && showCalendar && !isCalendarVisible && (
        <div
          style={{
            position: "absolute",
            top: "120px",
            right: "20px",
            zIndex: 1000,
          }}
        >
          <Button icon="event" onClick={() => setIsCalendarVisible(true)}>
            Show Date
          </Button>
        </div>
      )}

      {customBackButton === false ? (
        <div
          className={[styles.hideButton, styles.backButtonContainer].join(" ")}
        >
          <Button icon="arrow_back" onClick={() => dispatch(toggleMap())}>
            Back
          </Button>
        </div>
      ) : null}
      <div className={[styles.hideButton, styles.menu].join(" ")}>
        <Button icon="menu" onClick={() => setIsNavShowing(!isNavShowing)}>
          Menu
        </Button>
      </div>
      {loading && (
        <div className={styles.loading}>
          <Loading color="gray" size={36} />
        </div>
      )}
    </>
  );
}
